import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const containerStyles = {
  columnGap: 2,
  display: 'grid',
  gridTemplate: 'auto 1fr 1fr 1fr/1fr 1fr',
  px: 2,
  rowGap: 1,
};

const HoursOfOperation = ({
  saturdayHours,
  sectionTitle,
  sundayHours,
  titleStyles,
  titleVariant,
  weekdayHours,
}) => {
  return (
    <Box sx={containerStyles}>
      <Typography sx={{ gridColumn: '1/3', ...titleStyles }} variant={titleVariant}>
        {sectionTitle}
      </Typography>
      <Typography variant="subtitle2">Monday – Friday</Typography>
      <Typography variant="subtitle2">{weekdayHours || '--'}</Typography>
      <Typography variant="subtitle2">Saturday</Typography>
      <Typography variant="subtitle2">{saturdayHours || '--'}</Typography>
      <Typography variant="subtitle2">Sunday</Typography>
      <Typography variant="subtitle2">{sundayHours || '--'}</Typography>
    </Box>
  );
};

HoursOfOperation.defaultProps = {
  sectionTitle: 'Hours of Operation',
  titleStyles: { color: 'text.secondary', fontWeight: 400 },
  titleVariant: 'subtitle2',
};

HoursOfOperation.propTypes = {
  saturdayHours: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string,
  sundayHours: PropTypes.string.isRequired,
  titleStyles: PropTypes.shape({}),
  titleVariant: PropTypes.string,
  weekdayHours: PropTypes.string.isRequired,
};

export default HoursOfOperation;
